import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CMSLanguageService } from '@markant-platform/shared/data-access';
import { CMSHeader } from '@markant-platform/shared/content/model';

@Injectable()
export class LocaleHeaderInterceptor implements HttpInterceptor {
  constructor(private cmsLanguageService: CMSLanguageService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone the request to add the new header
    const request = req.clone({
      headers: req.headers.set(CMSHeader.PLATFORM_LOCALE_HEADER, this.cmsLanguageService.activeCMSLanguage),
    });

    return next.handle(request);
  }
}
